import React, { useCallback, useState } from 'react'
import { Button, Modal, Typography } from 'antd'
import { WifiOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { noInternetModalSelector } from 'app-redux/selectors'
import { closeNoInternetModal } from 'app-redux/networkSlice'

const { Text, Title } = Typography

const NoInternetModal = () => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const showModal = useSelector(noInternetModalSelector)
  const [checkingConnection, setCheckingConnection] = useState(false)

  const handleRetry = useCallback(() => {
    setCheckingConnection(true)
    setTimeout(() => {
      if (navigator.onLine) {
        dispatch(closeNoInternetModal())
      }
      setCheckingConnection(false)
    }, 350)
  }, [dispatch])

  return (
    <Modal open={showModal} footer={null} closable={false} maskClosable={false} destroyOnHidden>
      <div className="text-center py-4">
        <WifiOutlined style={{ fontSize: 56, color: '#faad14', marginBottom: 16 }} />
        <Title level={4} className="mb-2">
          {formatMessage({ id: 'network.no_internet_title' })}
        </Title>
        <Text type="secondary">{formatMessage({ id: 'network.no_internet_description' })}</Text>
        <div className="mt-4">
          <Button type="primary" loading={checkingConnection} onClick={handleRetry}>
            {formatMessage({ id: 'button.retry' })}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default NoInternetModal
